<template>
  <div class="app-container">
    <InputDatePicker
      ref="birth"
      :date.sync="form.birthday"
      :title="$t('birth')"
    />

    <md-button
      type="primary"
      :inactive="!form.birthday"
      style="margin-top: 260px;"
      @click="handleSubmit"
    >
      {{ $t('confirm') }}
    </md-button>
  </div>
</template>

<script>
import InputDatePicker from '@/components/InputDatePicker/index.vue'
import { Button } from 'mand-mobile'
import { checkBirthday } from '@/api/me'

export default {
  name: 'CheckBirthday',
  components: {
    InputDatePicker,
    [Button.name]: Button
  },

  data () {
    return {
      inactive: true,
      form: {
        birthday: ''
      }
    }
  },

  methods: {
    async handleSubmit () {
      await checkBirthday(this.form)
      this.$router.push({ name: 'MeChangePayPassword' })
    }
  }
}
</script>

<style scoped>

</style>
